import React from "react";

import "../css/Footer.css";

const ToxicFooter = props => {
  return (
    <div>
      <div id="toxiccityfoot" className="footerbar">
        <h2 className="footerheading">TOXIC CITY: SICK SCHOOLS SERIES</h2>
        <div className="flexcontainer">
          <div className="flexitem">
            <a href="http://www.philly.com/philly/news/lead-paint-poison-children-asbestos-mold-schools-philadelphia-toxic-city.html">
              <div className="thumbnail">
                <img
                  alt="toxic city part 1"
                  src="//media.inquirer.com/storage/special_projects/images/RS_phillyThumb2_1200x800_20180503_TOXICCITY3_YA.JPG"
                />
              </div>
              <div className="kicker upper dib">Part 1</div>
              <h2 className="block__headline gray--dark-5 space-half--btm">
                <div
                  className="block__link"
                  href="/"
                  data-link-type="main-stories-nav"
                >
                  DANGER: Learn at your own risk
                </div>
              </h2>

              <div className="">
                Philadelphia public-school children are often exposed to hazards
                such as lead, mold and asbestos fibers that can make them sick.
                School staffers helped Inquirer and Daily News reporters conduct
                scientific testing for these hazards inside classrooms and gyms.{" "}
              </div>
            </a>
          </div>

          <div className="flexitem">
            <a href="http://www.philly.com/philly/news/asbestos-testing-mesothelioma-cancer-philadelphia-schools-toxic-city.html">
              <div className="thumbnail">
                <img
                  alt="toxic city part 2"
                  src="//media.inquirer.com/storage/special_projects/images/toxiccity3_asbestos_thumb.jpg"
                />
              </div>
              <div className="kicker upper dib">Part 2</div>
              <h2 className="block__headline gray--dark-5 space-half--btm">
                <div
                  className="block__link"
                  href="/"
                  data-link-type="main-stories-nav"
                >
                  Hidden peril
                </div>
              </h2>
              <div className="">
                Philadelphia public schools are filled with acres of damaged
                asbestos in ceilings, floor tiles and insulation. We examine
                whether the district is doing enough to protect students from
                exposure to the cancerous fibers.
              </div>
            </a>
          </div>
          <div className="flexitem">
            <a href="http://www.philly.com/philly/news/lead-carbon-monoxide-silica-poisoning-construction-students-teachers-philadelphia-schools-toxic-city.html">
              <div className="thumbnail">
                <img
                  alt="toxic city part 3"
                  src="//media.inquirer.com/storage/special_projects/images/RS1153387_TOXICCITY3-D.JPG"
                />
              </div>
              <div className="kicker upper dib">Part 3</div>
              <h2 className="block__headline gray--dark-5 space-half--btm">
                <div
                  className="block__link"
                  href="/"
                  data-link-type="main-stories-nav"
                >
                  Botched jobs
                </div>
              </h2>

              <div className="">
                Too often when the Philadelphia school district has done
                much-needed repairs, the work has been shoddy, money was wasted,
                and, in one case, kids ended up in the ER.
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="footerWrapper">
        <div className="footerInner">
          <div className="footerCopywrite">
            © Copyright 2018 Philadelphia Media Network (Digital), LLC
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToxicFooter;



// WEBPACK FOOTER //
// ./src/components/Footer.js